'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Navbar from '../../../../components/Navbar';
import Footer from '../../../../components/Footer';
import PropertyCard from '../../../../components/PropertyCard';
import FilterPanel from '../../../../components/FilterPanel';
import HorizontalFilterBar from '../../../../components/HorizontalFilterBar';
import AdBanner from '../../../../components/AdBanner';
import Cookies from 'js-cookie';
import { api } from '@/lib/apiClient';
import { useSearchParams, useRouter } from 'next/navigation';

const BASE_URL = process.env.NEXT_PUBLIC_API_URL || '/api/proxy/';

// Mock data - API ready structure
const mockProperties = [
    {
        id: 'prop-001',
        title: '3 BHK Premium Apartment in Adyar',
        price: 95,
        priceUnit: 'Lac',
        pricePerSqft: 8500,
        type: 'Apartment',
        bedrooms: 3,
        bathrooms: 2,
        area: 1120,
        areaUnit: 'sqft',
        locality: 'Adyar',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600',
        imageCount: 8,
        badges: ['Ready to Move'],
        isNew: true,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
        possessionStatus: 'Ready to Move',
        age: 'New'
    },
    {
        id: 'prop-002',
        title: '2 BHK Modern Flat near IT Park',
        price: 68,
        priceUnit: 'Lac',
        pricePerSqft: 7200,
        type: 'Apartment',
        bedrooms: 2,
        bathrooms: 2,
        area: 945,
        areaUnit: 'sqft',
        locality: 'OMR',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600',
        imageCount: 12,
        badges: [],
        isNew: false,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
        possessionStatus: 'Ready to Move',
        age: '5 Years'
    },
    {
        id: 'prop-003',
        title: '4 BHK Luxury Villa with Pool',
        price: 2.5,
        priceUnit: 'Cr',
        pricePerSqft: 12000,
        type: 'Villa',
        bedrooms: 4,
        bathrooms: 4,
        area: 2200,
        areaUnit: 'sqft',
        locality: 'ECR',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=600',
        imageCount: 15,
        badges: ['Premium'],
        isNew: true,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
        possessionStatus: 'Ready to Move',
        age: 'New'
    },
    {
        id: 'prop-004',
        title: '3 BHK Apartment near Metro',
        price: 82,
        priceUnit: 'Lac',
        pricePerSqft: 7800,
        type: 'Apartment',
        bedrooms: 3,
        bathrooms: 2,
        area: 1050,
        areaUnit: 'sqft',
        locality: 'Velachery',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=600',
        imageCount: 6,
        badges: ['No Brokerage'],
        isNew: false,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
        possessionStatus: 'Under Construction',
        age: 'New'
    },
    {
        id: 'prop-005',
        title: '2 BHK Apartment in Thoraipakkam',
        price: 55,
        priceUnit: 'Lac',
        pricePerSqft: 6800,
        type: 'Apartment',
        bedrooms: 2,
        bathrooms: 2,
        area: 810,
        areaUnit: 'sqft',
        locality: 'Thoraipakkam',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1560185127-6ed189bf02f4?w=600',
        imageCount: 5,
        badges: [],
        isNew: false,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
        possessionStatus: 'Ready to Move',
        age: '8 Years'
    },
    {
        id: 'prop-006',
        title: '3 BHK Flat with Garden View',
        price: 1.2,
        priceUnit: 'Cr',
        pricePerSqft: 9500,
        type: 'Apartment',
        bedrooms: 3,
        bathrooms: 3,
        area: 1260,
        areaUnit: 'sqft',
        locality: 'Anna Nagar',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600',
        imageCount: 10,
        badges: ['Verified'],
        isNew: true,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
        possessionStatus: 'Ready to Move',
        age: '12 Years'
    },
];

// Dynamic Ad Data will replace mockAdData
const sortOptions = [
    { value: 'relevance', label: 'Relevance' },
    { value: 'newest', label: 'Newest First' },
    { value: 'price_low', label: 'Price: Low to High' },
    { value: 'price_high', label: 'Price: High to Low' },
];

function convertToArray(str) {
    if (!str) return [];
    return str.split('-').map(num => parseInt(num, 10));
}

export default function BuyListingPage() {
    const [filters, setFilters] = useState({});
    const [sortBy, setSortBy] = useState('relevance');
    const [properties, setProperties] = useState([]);
    const [filteredProperties, setFilteredProperties] = useState([]);
    const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
    const searchParams = useSearchParams();
    const router = useRouter();
    const cityId = searchParams.get("cityId");
    const [city_name, setCityName] = useState("");
    const [localities, setLocalities] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [parms, setParms] = useState("");
    const token = Cookies.get('token');
    const isLoggedIn = !!token;
    // Read localities from query params if any are present
    const localitiesParam = searchParams.get("localities");
    const initialLocalities = localitiesParam ? localitiesParam.split('-').map(num => parseInt(num, 10)) : [];

    const [localitiesIds, setLocalitiesIds] = useState(initialLocalities);



    useEffect(() => {
        fetchProperties();
    }, [searchParams]);

    useEffect(() => {
        let filtered = [...properties];

        // Property Type
        if (filters.propertyType?.length) {
            filtered = filtered.filter(p =>
                filters.propertyType.includes(p.type?.toLowerCase())
            );
        }

        // BHK
        if (filters.bhk?.length) {
            filtered = filtered.filter(p =>
                filters.bhk.includes(p.bedrooms?.toString())
            );
        }

        // Budget (IMPORTANT: price Lac/Cr mix)
        if (filters.budgetMin !== undefined) {
            filtered = filtered.filter(p => {
                let priceInLac = p.price;

                // Convert Cr → Lac
                if (p.priceUnit === 'Cr') {
                    priceInLac = p.price * 100;
                }

                return (
                    priceInLac >= filters.budgetMin &&
                    (filters.budgetMax === null || priceInLac <= filters.budgetMax)
                );
            });
        }

        // Furnishing
        if (filters.furnishing?.length) {
            filtered = filtered.filter(p => {
                const f = p.furnishing?.toLowerCase() || '';
                return filters.furnishing.some(opt => {
                    if (opt === 'semi') return f.includes('semi');
                    if (opt === 'unfurnished') return f.includes('unfurnished');
                    if (opt === 'furnished') return f.includes('furnished') && !f.includes('semi') && !f.includes('unfurnished');
                    return false;
                });
            });
        }

        // Status
        if (filters.status?.length) {
            filtered = filtered.filter(p => {
                const s = p.possessionStatus?.toLowerCase() || '';
                return filters.status.some(opt => {
                    if (opt === 'ready') return s.includes('ready');
                    if (opt === 'construction') return s.includes('construction') || s.includes('under');
                    return false;
                });
            });
        }

        // Posted By
        if (filters.postedBy?.length) {
            filtered = filtered.filter(p => {
                const posted = p.postedBy?.toLowerCase() || '';
                return filters.postedBy.some(opt => posted.includes(opt));
            });
        }

        setFilteredProperties(filtered);

    }, [filters, properties]);

    const fetchProperties = async () => {
        try {
            console.log("searchParams", searchParams.toString());
            setParms(searchParams.toString());
            const localitiesArray = convertToArray(searchParams.get("localities"));
            setLocalitiesIds(localitiesArray);
            let whereClause = "property_type!=6 and listing_type=$1 and city_id=$2";
            let params = ['sell', cityId];

            const res = await api.post('selectwithout/view_home_cities', { sqlData: "*", where: "id=$1", whereData: [cityId] });
            //console.log("res.data", res.data);
            let city_name = res.data[0].name;
            setCityName(city_name);
            const res1 = await api.post('selectwithout/master_localities', {
                sqlData: "locality_name as name",
                where: "id = ANY($1)",
                whereData: [localitiesArray],
            });
            if (res1.success === 1 && Array.isArray(res1.data)) {
                let localitiesNames = "";
                for (let i = 0; i < res1.data.length; i++) {
                    localitiesNames += res1.data[i].name + ", ";
                }
                setLocalities(localitiesNames);
            }

            if (localitiesArray && localitiesArray.length > 0) {
                whereClause += " and locality_id = ANY($3)";
                params.push(localitiesArray);
            }

            whereClause += " order by created_at desc";

            const response = await api.post('selectwithout/view_home_listings',
                {
                    sqlData: "*",
                    where: whereClause,
                    whereData: params,
                });
            console.log("response.data", response.data);
            let property_card = [];
            for (let i = 0; i < response.data.length; i++) {
                property_card.push(response.data[i].property_card);
            }
            setProperties(property_card);
        } catch (error) {
            console.error('Error fetching properties:', error);
        }
    };

    // const fetchAds = async () => {
    //     try {
    //         const adsRes = await api.post('selectwithout/ad_listing_det', { sqlData: '*', where: 'is_live=$1', whereData: [true] });
    //         if (adsRes.success === 1 && Array.isArray(adsRes.data)) {
    //             let validAds = adsRes.data.filter(ad => {
    //                 if (!ad.view_places) return false;
    //                 try {
    //                     let vp = typeof ad.view_places === 'string' ? JSON.parse(ad.view_places) : ad.view_places;
    //                     if (Array.isArray(vp)) return vp.includes('sell');
    //                     return typeof ad.view_places === 'string' && ad.view_places.toLowerCase().includes('sell');
    //                 } catch (e) {
    //                     return typeof ad.view_places === 'string' && ad.view_places.toLowerCase().includes('sell');
    //                 }
    //             });

    //             validAds.sort(() => 0.5 - Math.random());
    //             validAds = validAds.slice(0, 2);

    //             if (validAds.length === 0) return;

    //             const listingIds = validAds.filter(a => a.listing_id).map(a => a.listing_id);
    //             const projectIds = validAds.filter(a => a.project_id).map(a => a.project_id);

    //             let listingsMap = {};
    //             let projectsMap = {};

    //             if (listingIds.length > 0) {
    //                 const listingPromises = listingIds.map(id =>
    //                     api.post('selectwithout/listings', { sqlData: 'id,featured_image_url,listing_type,property_sub_type', where: 'id=$1', whereData: [id] })
    //                 );
    //                 const resArray = await Promise.all(listingPromises);
    //                 resArray.forEach(res => {
    //                     if (res.success === 1 && Array.isArray(res.data)) {
    //                         res.data.forEach(l => listingsMap[l.id] = l);
    //                     }
    //                 });
    //             }
    //             if (projectIds.length > 0) {
    //                 const projectPromises = projectIds.map(id =>
    //                     api.post('selectwithout/projects', { sqlData: 'id,featured_image_url', where: 'id=$1', whereData: [id] })
    //                 );
    //                 const resArray = await Promise.all(projectPromises);
    //                 resArray.forEach(res => {
    //                     if (res.success === 1 && Array.isArray(res.data)) {
    //                         res.data.forEach(p => projectsMap[p.id] = p);
    //                     }
    //                 });
    //             }

    //             const mappedAds = await Promise.all(validAds.map(async (ad) => {
    //                 let image = '/no-image.jpeg';
    //                 let link = '#';
    //                 let isExternal = false;

    //                 if (ad.listing_id && listingsMap[ad.listing_id]) {
    //                     const l = listingsMap[ad.listing_id];
    //                     if (l.featured_image_url) image = BASE_URL + l.featured_image_url;
    //                     if (l.property_sub_type != 6 && l.listing_type == "sell") {
    //                         link = `/property/${l.id}`;
    //                     } else {
    //                         link = `/rent/p/${l.id}`;
    //                     }
    //                 } else if (ad.project_id && projectsMap[ad.project_id]) {
    //                     const p = projectsMap[ad.project_id];
    //                     if (p.featured_image_url) image = BASE_URL + p.featured_image_url;
    //                     link = `/projects/p/${ad.project_id}`;
    //                     isExternal = true;
    //                 }

    //                 try {
    //                     const currentViews = ad.views || 0;
    //                     await api.post(`updatewithout/ad_listing_det/${ad.id}`, { views: currentViews + 1 }, { skipAuthGuard: true });

    //                 } catch (e) {
    //                     console.error("Error updating views", e);
    //                 }

    //                 return {
    //                     id: ad.id,
    //                     title: ad.ad_head || 'Advertisement',
    //                     description: ad.short_desc || '',
    //                     image: image,
    //                     ctaText: 'View Details',
    //                     link: link,
    //                     isExternal: isExternal,
    //                     rawAd: ad
    //                 };
    //             }));

    //             setDynamicAdBanners(mappedAds);
    //         }
    //     } catch (e) {
    //         console.error('Error fetching ads', e);
    //     }
    // };

    // const handleAdClick = async (ad) => {
    //     try {
    //         if (!isLoggedIn) {
    //             alert("Please login to click on the ad");
    //             return;
    //         } else {
    //             const link = ad.link;
    //             const currentClicks = ad.rawAd.clicks || 0;
    //             await api.post(`updatewithout/ad_listing_det/${ad.id}`, { clicks: currentClicks + 1 }, { skipAuthGuard: true });
    //             if (ad.isExternal) {
    //                 window.open(ad.link, '_blank', 'noopener,noreferrer');
    //             } else {
    //                 router.push(ad.link);
    //             }
    //         }
    //     } catch (e) {
    //         console.error("Error updating clicks", e);
    //     }
    // };

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        // API call will go here to fetch filtered properties
        console.log('Filters changed:', newFilters);
    };

    const handleSave = (propertyId) => {
        // API call to save property
        console.log('Save property:', propertyId);
    };

    return (
        <>
            <Navbar />
            <main className="min-h-screen bg-gray">
                {/* Page Header */}
                {/* Horizontal Filter Bar - Sticky */}
                <div className="hidden lg:block sticky top-16 z-40 shadow-lg shadow-primary/10">
                    <HorizontalFilterBar
                        filters={filters}
                        onChange={handleFilterChange}
                        listingType="buy"
                    />
                </div>

                {/* Page Header */}
                <div className="bg-gray">
                    <div className="container-custom py-4">
                        {/* BOTTOM: Title left + Relevance Right */}
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-5 mb-3">
                            <nav className="flex items-center gap-2 text-sm text-gray-500" aria-label="Breadcrumb">
                                <span className="text-gray-900 font-medium">
                                    <strong> Available {filteredProperties.length} Properties </strong>  for Sale in {localities} {city_name}.
                                </span>
                            </nav>
                            {/* RIGHT – Relevance Select */}
                            {/* <div className="flex items-center justify-between md:justify-end gap-2 w-full md:w-auto">
                                <label htmlFor="sortBy" className="text-sm text-gray-600 whitespace-nowrap">
                                    Sort by:
                                </label>
                                <select
                                    id="sortBy"
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                    className="h-9 w-full md:w-auto text-sm px-2 rounded-md bg-white border border-gray-300 text-gray-700 shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                                >
                                    {sortOptions.map((opt) => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </select>
                            </div> */}

                        </div>
                    </div>
                </div>

                {/* Main Content Split Layout */}
                <div className="container-custom py-8">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">

                        {/* Left: Property List (8 cols) */}
                        <div className="lg:col-span-8 flex flex-col gap-3">
                            {/* Mobile Filter Button */}
                            <div className="lg:hidden fixed bottom-0 left-0 right-0 z-10 bg-white border-t shadow-lg p-4">
                                <button
                                    onClick={() => setIsMobileFilterOpen(true)}
                                    className="btn btn-primary w-full flex justify-between items-center"
                                >
                                    <span className="flex items-center gap-2">
                                        <svg
                                            className="w-5 h-5"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                                            />
                                        </svg>
                                        Filters
                                    </span>

                                    {Object.keys(filters).length > 0 && (
                                        <span className="bg-primary text-white text-xs px-2 py-0.5 rounded-full">
                                            {Object.keys(filters).length}
                                        </span>
                                    )}
                                </button>
                            </div>

                            {/* Property Cards */}
                            {filteredProperties.map((property) => (
                                <PropertyCard
                                    key={property.id}
                                    property={property}
                                    onSave={handleSave}
                                    params={parms}
                                    listingType='buy'
                                    variant="horizontal"
                                />
                            ))}

                            {/* Load More */}
                            {/* <div className="mt-8 text-center">
                                <button className="btn btn-white border border-gray-200 hover:border-primary hover:text-primary px-8 w-full sm:w-auto">
                                    Load More Properties
                                </button>
                            </div> */}
                        </div>

                        {/* Right: Ad Sidebar (4 cols) */}
                        <aside className="lg:col-span-4 hidden lg:flex flex-col gap-6 sticky top-24">
                            {/* Featured / Ad Widget 1 */}
                            {/* <div className="p-6 bg-violet-50 rounded-2xl border border-violet-100">
                                <h3 className="text-lg font-bold text-violet-900 mb-2">Need Help Buying?</h3>
                                <p className="text-sm text-violet-700 mb-4">
                                    Get expert advice from our property consultants. Free consultation for premium members.
                                </p>
                                <button className="w-full btn bg-violet-600 text-white hover:bg-violet-700 border-none">
                                    Contact Expert
                                </button>
                            </div> */}

                            {/* Ad Banners */}
                            <AdBanner
                                type="sell"
                                noofads={2}
                            />
                        </aside>

                    </div>
                </div>

                {/* Mobile Filter Modal */}
                {isMobileFilterOpen && (
                    <div className="fixed inset-0 z-50 lg:hidden">
                        <div
                            className="absolute inset-0 bg-black/50"
                            onClick={() => setIsMobileFilterOpen(false)}
                        />
                        <div className="absolute right-0 top-0 bottom-0 w-full max-w-sm bg-white overflow-y-auto">
                            <FilterPanel
                                filters={filters}
                                onChange={handleFilterChange}
                                listingType="buy"
                                isMobile={true}
                                onClose={() => setIsMobileFilterOpen(false)}
                            />
                        </div>
                    </div>
                )}
            </main>
            <Footer />
        </>
    );
}
